export const widgetSelector = (uuid: string): string => `#sd-hero-image-${uuid}`;

export const HERO_IMAGE_CLASS = 'sd-hero-image';
export const heroImageSelector = (uuid: string): string => `${HERO_IMAGE_CLASS}-${uuid}`;
export const heroImageClassName = (uuid: string): string => `.${heroImageSelector(uuid)}`;
